// Copyright (c) Microsoft. All rights reserved.

import { TabValue } from '@fluentui/react-components';
import React from 'react';
import { Alerts } from '../../components/shared/Alerts';
import { ChatRoom } from './ChatRoom';

export const ChatWindow: React.FC = () => {
  const [selectedTab, _setSelectedTab] = React.useState<TabValue>('chat');
  const scrollViewTargetRef = React.useRef<HTMLDivElement>(null);

  return (
    <main className="chat-main" ref={scrollViewTargetRef}>
      {selectedTab === 'chat' && <ChatRoom scrollViewTargetRef={scrollViewTargetRef} />}
      {selectedTab !== 'chat' && (
        <div>
          <Alerts />
        </div>
      )}
    </main>
  );
};
